var _path, _path2, _path3, _path4, _mask, _path5, _circle, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIdentification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11V6C5 5.44772 5.44772 5 6 5H11",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21L27 26C27 26.5523 26.5523 27 26 27L21 27",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5L26 5C26.5523 5 27 5.44772 27 6L27 11",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27L6 27C5.44772 27 5 26.5523 5 26L5 21",
    stroke: "currentColor",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_3442_108624",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14C15.6111 14 9 15.5 9 20L9 22C9 22.5523 9.44771 23 10 23L22 23C22.5523 23 23 22.5523 23 22L23 20C23 15.5 16.3889 14 16 14Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14L15.9999 12L16 14ZM9 20L11 20V20L9 20ZM9 22L11 22V22L9 22ZM10 23L10 25H10L10 23ZM22 23L22 21H22V23ZM23 22L25 22V22L23 22ZM23 20H21V20L23 20ZM15.9999 12C15.782 12 15.576 12.0369 15.516 12.0473C15.4033 12.0668 15.2766 12.0928 15.1421 12.1235C14.8713 12.1854 14.5306 12.2753 14.1452 12.3959C13.3798 12.6353 12.3863 13.0113 11.389 13.5608C9.49523 14.6043 7 16.6247 7 20L11 20C11 18.8753 11.8103 17.8957 13.3194 17.0642C14.0234 16.6762 14.7556 16.396 15.3392 16.2135C15.6282 16.1231 15.8678 16.0607 16.033 16.023C16.1165 16.0039 16.1718 15.9933 16.1986 15.9886C16.2782 15.9748 16.1694 16 16.0001 16L15.9999 12ZM7 20L7 22L11 22L11 20L7 20ZM7 22C7 23.6569 8.34315 25 10 25L10 21C10.5523 21 11 21.4477 11 22L7 22ZM10 25L22 25V21L10 21L10 25ZM22 25C23.6568 25 25 23.6569 25 22L21 22C21 21.4477 21.4477 21 22 21L22 25ZM25 22L25 20L21 20L21 22L25 22ZM25 20C25 16.6247 22.5048 14.6043 20.611 13.5608C19.6137 13.0112 18.6202 12.6352 17.8548 12.3958C17.4694 12.2753 17.1287 12.1853 16.8579 12.1235C16.7234 12.0927 16.5967 12.0668 16.4839 12.0473C16.424 12.0369 16.2179 12 15.9999 12L16.0001 16C15.8307 16 15.7218 15.9748 15.8015 15.9886C15.8283 15.9933 15.8835 16.0039 15.967 16.023C16.1322 16.0607 16.3718 16.1231 16.6608 16.2135C17.2444 16.396 17.9766 16.6762 18.6806 17.0642C20.1897 17.8957 21 18.8753 21 20H25Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-1_3442_108624)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 19,
    rx: 1,
    ry: 1,
    transform: "rotate(-90 18 19)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIdentification);
export default __webpack_public_path__ + "static/media/UserIdentification.ded76413.svg";
export { ForwardRef as ReactComponent };